import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangePickerComponent } from './date-range-picker.component';
import { FormsModule } from '@angular/forms';
import { NgDatepickerModule } from 'ng2-datepicker';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, NgDatepickerModule, TranslateModule],
  declarations: [DateRangePickerComponent],
  exports: [DateRangePickerComponent],
})
export class DateRangePickerModule {}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.module.ts